import styles from './commonLayout.module.css';
import DOMPurify from 'dompurify';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import { useEffect } from 'react';
import { useRef } from 'react';
gsap.registerPlugin(ScrollTrigger)
const CommonLayout = ({
  header,
  text,
  direction = 'forward',
  imgSrc,
  textSize,
  videoSrc,
  videoPlayEffect,
  loop,
  playsInline,
  muted,
  preload,
  poster
}) => {
  const videoRef = useRef(null)
  useEffect(() => {
    if(videoPlayEffect) {
      ScrollTrigger.create({
        trigger:videoRef.current,
        start:'top 80%',
        onEnter:() => {
          videoRef.current.play()
        }
      })
    }
  },[])
  return direction === 'reverse' ? (
    <div className={styles.ctn}>
      {videoSrc ? (
        <video src={videoSrc} loop={loop} playsInline={playsInline} muted={muted} preload={preload} ref={videoRef} poster={poster}></video>
      ) : (
        <img src={imgSrc} alt="" />
      )}

      <div className={styles.textBox}>
        <h3
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(header),
          }}
        ></h3>
        {textSize === 'big' ? (
          <h4
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(text),
            }}
          ></h4>
        ) : (
          <h5
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(text),
            }}
          ></h5>
        )}
      </div>
    </div>
  ) : (
    <div className={styles.ctn}>
      <div className={styles.textBox}>
        <h3
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(header),
          }}
        ></h3>
        {textSize === 'big' ? (
          <h4
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(text),
            }}
          ></h4>
        ) : (
          <h5
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(text),
            }}
          ></h5>
        )}
      </div>
      {videoSrc ? (
        <video src={videoSrc}loop={loop} playsInline={playsInline} muted={muted} preload={preload} ref={videoRef} poster={poster}></video>
      ) : (
        <img src={imgSrc} alt="" />
      )}
    </div>
  );
};

export default CommonLayout;
